[
	{
	  "lineOfBusiness": "Commercial Business Owners",
	  "policySymbol": "BOP",
	  "quoteSymbol": "BPQ",
	  "lob": "BOP",
	  "insLineCode": "BOP",
	  "insuranceLine": "BOP",
	  "description": "Businessowners"
	},
	{
	  "lineOfBusiness": "Commercial Package",
	  "policySymbol": "CPP",
	  "quoteSymbol": "CPQ",
	  "lob": "CPP",
	  "insLineCode": "CA",
	  "insuranceLine": "Coml Auto",
	  "description": "Commercial Auto"
	},
	{
	  "lineOfBusiness": "Commercial Package",
	  "policySymbol": "CPP",
	  "quoteSymbol": "CPQ",
	  "lob": "CPP",
	  "insLineCode": "CF",
	  "insuranceLine": "Fire",
	  "description": "Commercial Fire"
	},
	{
	  "lineOfBusiness": "Commercial Package",
	  "policySymbol": "CPP",
	  "quoteSymbol": "CPQ",
	  "lob": "CPP",
	  "insLineCode": "GL",
	  "insuranceLine": "General Liability",
	  "description": "General Liability"
	},
	{
	  "lineOfBusiness": "Commercial Package",
	  "policySymbol": "CPP",
	  "quoteSymbol": "CPQ",
	  "lob": "CPP",
	  "insLineCode": "IMC",
	  "insuranceLine": "Inland Marine",
	  "description": "Commercial Inland Marine"
	},
	{
	  "lineOfBusiness": "Commercial Package",
	  "policySymbol": "CPP",
	  "quoteSymbol": "CPQ",
	  "lob": "CPP",
	  "insLineCode": "CR",
	  "insuranceLine": "Crime",
	  "description": "Crime"
	},
	{
	  "lineOfBusiness": "Commercial Package",
	  "policySymbol": "CPP",
	  "quoteSymbol": "CPQ",
	  "lob": "CPP",
	  "insLineCode": "PL",
	  "insuranceLine": "Professional",
	  "description": "Professional Liability"
	},
	{
	  "lineOfBusiness": "Commercial Umbrella",
	  "policySymbol": "UMC",
	  "quoteSymbol": "QMC",
	  "lob": "UMC",
	  "insLineCode": "UMC",
	  "insuranceLine": "Coml Excess",
	  "description": "Excess"
	},
	{
	  "lineOfBusiness": "Farm",
	  "policySymbol": "FPP",
	  "quoteSymbol": "FPQ",
	  "lob": "FRM",
	  "insLineCode": "FA",
	  "insuranceLine": "Farm Auto",
	  "description": "Farm Auto"
	},
	{
	  "lineOfBusiness": "Farm",
	  "policySymbol": "FPP",
	  "quoteSymbol": "FPQ",
	  "lob": "FRM",
	  "insLineCode": "FD",
	  "insuranceLine": "Farm Dwelling",
	  "description": "Farm Dwelling"
	},
	{
	  "lineOfBusiness": "Farm",
	  "policySymbol": "FPP",
	  "quoteSymbol": "FPQ",
	  "lob": "FRM",
	  "insLineCode": "FGL",
	  "insuranceLine": "Farm General Liability",
	  "description": "Farm General Liability"
	},
	{
	  "lineOfBusiness": "Farm",
	  "policySymbol": "FPP",
	  "quoteSymbol": "FPQ",
	  "lob": "FRM",
	  "insLineCode": "FL",
	  "insuranceLine": "Farm Liability",
	  "description": "Farm Liability"
	},
	{
	  "lineOfBusiness": "Farm",
	  "policySymbol": "FPP",
	  "quoteSymbol": "FPQ",
	  "lob": "FRM",
	  "insLineCode": "FIM",
	  "insuranceLine": "Farm Inland Marine",
	  "description": "Farm Inland Marine"
	},
	{
	  "lineOfBusiness": "Farm",
	  "policySymbol": "FPP",
	  "quoteSymbol": "FPQ",
	  "lob": "FRM",
	  "insLineCode": "FP",
	  "insuranceLine": "Farm Property",
	  "description": "Farm Personal Property"
	},
	{
	  "lineOfBusiness": "Farm",
	  "policySymbol": "FPP",
	  "quoteSymbol": "FPQ",
	  "lob": "FRM",
	  "insLineCode": "FS",
	  "insuranceLine": "Farm Structures",
	  "description": "Farm Structures"
	}
  ]